export default {"src":"/_next/static/media/confused.b39061e9.svg","height":62,"width":53,"blurWidth":0,"blurHeight":0};